import { render, staticRenderFns } from "./IndumentariasRecogidas.vue?vue&type=template&id=44b6d451"
import script from "./IndumentariasRecogidas.vue?vue&type=script&lang=js"
export * from "./IndumentariasRecogidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports